// extracted by mini-css-extract-plugin
module.exports = {"franja":"franja_franja__1yB8h","franjaLight":"franja_franjaLight__2bpXH"};